<template>
  <v-card class="px-2">
    <v-card-title>
      Your Order History
    </v-card-title>
    <v-card-subtitle>
      View your order history and download invoices
    </v-card-subtitle>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table-thead, table-tbody"
      ></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="billing_history"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
      >
        <template v-slot:item.date="{ item }">
          {{ item.date | normalDate }}
        </template>
        <template v-slot:item.amount="{ item }">
          {{ item.amount | currency }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            text
            class="light-background"
            small
            color="info"
            :href="item.invoiceUrl"
          >
            View
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HistoryCard",
  components: {},
  props: {
    loading: { type: Boolean, default: false }
  },
  data: () => ({
    search: "",
    options: {},
    headers: [
      { text: "ID", value: "id" },
      { text: "Date", value: "date" },
      { text: "Amount", value: "amount" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),
  computed: {
    ...mapGetters({ billing_history: "billing/billing_history" })
  },
  created() {},
  methods: {}
};
</script>
